import catalogueService from '../../api/cataloguefile'

const state = {
    files: [],
    paginationInfo: { totalPages: 0, size: 0, number: 0 },
    records: [],
    pendingRecords: [],
    numberOfLinks: 0,
    numberOfItemsPerPage: 7,
    currentPage: 0,
    loading: false

}

const mutations = {
    setFiles (state, files) {
        state.files = files
    },
    setFilesWithPagination (state, response) {
        state.paginationInfo = response.data.page

        state.files = response.data.content
    },

    setRecords (state, records) {
        state.records = records
    },
    setPendingRecords (state, records) {
        state.pendingRecords = records
    },

    setLoading (state, payload) {
        state.loading = payload
    }

}

const actions = {
    getFiles ({ commit }) {
        catalogueService.getFiles().then(response => {
            commit('setFiles', response.data)
        }).catch(error => {
            console.log(error)
        })
    },
    getFilesWithPagination ({ commit }, payload) {
        commit('setLoading', true)
        catalogueService.getFilesWithPagination(payload).then(response => {
            commit('setFilesWithPagination', response)
            commit('setLoading', false)
        }).catch(error => {
            commit('setLoading', false)
            console.log(error)
        })
    },
    uploadFile ({ commit }, formData) {
        return new Promise((resolve, reject) => {
            catalogueService.uploadFile(formData).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    approveFile ({ commit }, file) {
        return new Promise((resolve, reject) => {
            catalogueService.approveFile(file).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    rejectFile ({ commit }, file) {
        return new Promise((resolve, reject) => {
            catalogueService.rejectFile(file).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    viewFile ({ commit }, fileId) {
        commit('setLoading', true) // Set loading state to true

        catalogueService.viewFile(fileId).then(response => {

            commit('setRecords', response.data)
            commit('setLoading', false)
        }).catch(error => {
            console.log(error)
            commit('setLoading', false)
        })
    },
    viewPendingCollection ({ commit }) {
        commit('setLoading', true) // Set loading state to true

        catalogueService.viewPendingCollection().then(response => {
            console.log("Loaded grn Records",response)
            commit('setRecords', response.data)
            commit('setLoading', false)
        }).catch(error => {
            console.log(error)
            commit('setLoading', false)
        })
    },
    resetcataloguefiles ({ commit }) {
        // console.log("Loaded grn Records",response)
        commit('setLoading', true)
        commit('setRecords', [])
    },
    viewDeletedFile ({ commit }, fileId) {
        catalogueService.viewDeletedFile(fileId).then(response => {
            commit('setRecords', response.data)
            // console.log('Grn>>>', response.data)
        }).catch(error => {
            console.log(error)
        })
    },
    download ({ commit }, fileId) {
        return new Promise((resolve, reject) => {
            catalogueService.download(fileId).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    warehouseApproveRecords ({ commit }, records) {
        return new Promise((resolve, reject) => {
            catalogueService.warehouseApproveRecords(records).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },

    warehouseApproveRecords2 ({ commit }, records) {
        return new Promise((resolve, reject) => {
            catalogueService.brokerApproveRecords(records).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    sweepingsApproveRecords ({ commit }, records) {
        console.log('hello===')
        return new Promise((resolve, reject) => {
            catalogueService.sweepingsApproveRecords(records).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    millerApproveRecord ({ commit }, record) {
        return new Promise((resolve, reject) => {
            catalogueService.millerApproveRecord(record).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    editRecord ({ commit }, record) {
        return new Promise((resolve, reject) => {
            catalogueService.editRecord(record).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getRecordsPendingApproval ({ commit }) {
        catalogueService.getRecordsPendingApproval().then(response => {
            commit('setPendingRecords', response.data)
        }).catch(error => {
            console.log(error)
        })
    },
    /*Sweepings*/
      viewSweepingsFile ({ commit }, fileId) {
        commit('setLoading', true) // Set loading state to true

        catalogueService.viewSweepingsFile(fileId).then(response => {
            console.log("Sweepings data structure",response.data)

            commit('setRecords', response.data)
            commit('setLoading', false)
        }).catch(error => {
            console.log(error)
            commit('setLoading', false)
        })
    },

      specilaityApprove ({ commit }, records) {
        return new Promise((resolve, reject) => {
            catalogueService.SpecialityRecords(records).then((res) => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
}

const getters = {
    isLoading (state) {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
